module.exports = __webpack_public_path__ + "img/20190622132515196.354efc1e.png";